import { cEl } from '../../../../../util';

function GuideSlide() {
    const guideSlide = cEl('article');
    guideSlide.classList.add('carousel-slide', 'guide-slide');
    guideSlide.innerHTML = `
    <h2>성공적인 병원 서비스 로봇 사용을 위한 핵심 가이드</h2>
    <p>
        병원 서비스 로봇은 단순히 전원을 연결한다고 바로 활용할 수 있는 것이 아닙니다. 비용을 투자하더라도, 충분한 준비와 고려가 없다면 효과적인 사용이 어렵습니다.<br>성공적인 로봇 운영을 위해 가장 중요한 것은 <span class="text-highlight">시나리오의 선택</span>입니다.
    </p>
    <p>
        사용 전, 다음의 항목을 충분히 고민해보세요:
    </p>
    <ul>    
        <li>성공적으로 활용하기 위한 시나리오 선택 기준</li>
        <li>비용 효율성을 높이기 위한 시나리오</li>
        <li>로봇 활용을 위한 병원 환경</li>
    </ul>
    `;
    return guideSlide;
}

export default GuideSlide;
